export const STORE_DETAILS_TAB_PARAM = 'sd_tab';

export const STORE_DETAILS_FEATURE_FLAGS_CLIENT_PARAM = 'sd_ff_client';

// Legacy param used before query param namespacing.
export const STORE_DETAILS_TAB_PARAM_LEGACY = 'tab';
